import React, { ReactNode } from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import * as styles from './Mission.module.scss'
import Logo from './assets/logo.svg'
import ExternalIcon from '../../assets/external.svg'
import SectionHead from '../section-head/SectionHead'

const Mission: React.FC = () => {
  const t = useIntl()

  return (
    <div className={styles.container}>
      <SectionHead
        title={t.formatMessage({ id: 'mission.title' })}
      />
      <div className={styles.hiring}>
        <h3 className={styles.subtitle}>
          {t.formatMessage({ id: 'mission.subtitle' })}
        </h3>
        <p className={styles.paragraph}>
          {t.formatMessage({ id: 'mission.paragraph1' })}
        </p>
        <p className={styles.paragraph}>
          {t.formatMessage({ id: 'mission.paragraph2' }, {
            company: (content: ReactNode) => (
              <a
                className={styles.companyLink}
                href='https://coderpad.io'
                target='_blank' rel='noreferrer'
              >
                <Logo className={styles.logo} />
                <span>{content}</span>
              </a>
            )
          })}
        </p>
        <p className={styles.paragraph}>
          {t.formatMessage({ id: 'mission.paragraph3' })}
        </p>

        <a target='_blank' className={styles.externalLink} href='https://coderpad.io' rel='noreferrer'>
          {t.formatMessage({ id: 'mission.link' })}
          <ExternalIcon />
        </a>

      </div>
    </div>
  )
}

export default Mission
